export const TYPES = {
  // Repositories
  IAuthRepository: Symbol.for('IAuthRepository'),
  ITenantRepository: Symbol.for('ITenantRepository'),
  IPlanRepository: Symbol.for('IPlanRepository'),
  IPanelFacturacionRepository: Symbol.for('IPanelFacturacionRepository'),
  IPanelPagoRepository: Symbol.for('IPanelPagoRepository'),
  IMercadoPagoRepository: Symbol.for('IMercadoPagoRepository'),
  IReportRepository: Symbol.for('IReportRepository'),
  ListPanelPagosAction: Symbol.for('ListPanelPagosAction'),
  CancelPanelPagoAction: Symbol.for('CancelPanelPagoAction'),
  CreateMpPreferenceAction: Symbol.for('CreateMpPreferenceAction'),
  GetFinancialReportAction: Symbol.for('GetFinancialReportAction'),
  GetClinicReportAction: Symbol.for('GetClinicReportAction'),
  GetCollectionsReportAction: Symbol.for('GetCollectionsReportAction'),
  GetSaasMetricsAction: Symbol.for('GetSaasMetricsAction'),
  GetEcosystemUsageAction: Symbol.for('GetEcosystemUsageAction'),
  GetReminderAnalyticsAction: Symbol.for('GetReminderAnalyticsAction'),
  
  // Actions - Auth
  LoginAction: Symbol.for('LoginAction'),
  Enable2FAAction: Symbol.for('Enable2FAAction'),
  Verify2FASetupAction: Symbol.for('Verify2FASetupAction'),
  Disable2FAAction: Symbol.for('Disable2FAAction'),
  GetCurrentUserAction: Symbol.for('GetCurrentUserAction'),
  LogoutAction: Symbol.for('LogoutAction'),
  ChangeUserTenantAction: Symbol.for('ChangeUserTenantAction'),
  
  // Actions - Tenant
  ListTenantsAction: Symbol.for('ListTenantsAction'),
  GetTenantAction: Symbol.for('GetTenantAction'),
  CreateTenantAction: Symbol.for('CreateTenantAction'),
  UpdateTenantAction: Symbol.for('UpdateTenantAction'),
  DeleteTenantAction: Symbol.for('DeleteTenantAction'),
  ChangeTenantStatusAction: Symbol.for('ChangeTenantStatusAction'),
  
  // Actions - Plan
  ListPlansAction: Symbol.for('ListPlansAction'),
  CreatePlanAction: Symbol.for('CreatePlanAction'),
  UpdatePlanAction: Symbol.for('UpdatePlanAction'),
  TogglePlanStatusAction: Symbol.for('TogglePlanStatusAction'),
  DeletePlanAction: Symbol.for('DeletePlanAction'),

  // Repositories - Adicional
  IAdicionalRepository: Symbol.for('IAdicionalRepository'),
  ITenantAdicionalRepository: Symbol.for('ITenantAdicionalRepository'),

  // Actions - Adicional
  ListAdicionalesAction: Symbol.for('ListAdicionalesAction'),
  CreateAdicionalAction: Symbol.for('CreateAdicionalAction'),
  UpdateAdicionalAction: Symbol.for('UpdateAdicionalAction'),
  ToggleAdicionalStatusAction: Symbol.for('ToggleAdicionalStatusAction'),
  DeleteAdicionalAction: Symbol.for('DeleteAdicionalAction'),
  
  // Actions - Billing
  ListBillingPanelsAction: Symbol.for('ListBillingPanelsAction'),
  GetBillingPanelAction: Symbol.for('GetBillingPanelAction'),
  
  // Services
  IEmailService: Symbol.for('IEmailService'),
  
  // HTTP Client
  HttpClient: Symbol.for('HttpClient'),

  // Repositories - Support
  ISupportTicketRepository: Symbol.for('ISupportTicketRepository'),

  // Actions - Support
  ListTicketsAction: Symbol.for('ListTicketsAction'),
  UpdateTicketAction: Symbol.for('UpdateTicketAction'),

  // Repositories - Emails (SendGrid)
  IEmailOutboundRepository: Symbol.for('IEmailOutboundRepository'),

  // Actions - Emails
  ListEmailsAction: Symbol.for('ListEmailsAction'),

  // Repositories - Help documentation
  IHelpDocumentationRepository: Symbol.for('IHelpDocumentationRepository'),

  // Actions - Help documentation
  ListHelpCategoriesAction: Symbol.for('ListHelpCategoriesAction'),
  SaveHelpCategoryAction: Symbol.for('SaveHelpCategoryAction'),
  ListHelpArticlesAction: Symbol.for('ListHelpArticlesAction'),
  GetHelpArticleAction: Symbol.for('GetHelpArticleAction'),
  GetHelpArticleBundleAction: Symbol.for('GetHelpArticleBundleAction'),
  SaveHelpArticleBundleAction: Symbol.for('SaveHelpArticleBundleAction'),
  TranslateHelpTextAction: Symbol.for('TranslateHelpTextAction'),
  SaveHelpArticleAction: Symbol.for('SaveHelpArticleAction'),
  GetHelpLayoutAction: Symbol.for('GetHelpLayoutAction'),
  SaveHelpLayoutAction: Symbol.for('SaveHelpLayoutAction'),
} as const;
